import { HTTP, BACKOFFICE } from '@/services/HTTPService';
import Vue from "vue";
import store from "../../store";
import i18n from "@/helpers/i18n";
import apiMimk from "@/api/master-classes/mimk";

export default {
  async lossReasons() {
    const response = await HTTP.get(`/bookings/loss_reasons/`);
    let countReasons = 0;
    for (var i in response.data) {
      if (response.data[i]) {
        countReasons++;
      }
    }
    if (!countReasons) {
      return [];
    }

    return response.data;
  },
  async firstConformation() {
    const response = await HTTP.get('/bookings/first_confirmations_list/');
    let countReasons = 0;
    for (var i in response.data) {
      if (response.data[i]) {
        countReasons++;
      }
    }
    if (!countReasons) {
      return [];
    }

    return response.data;
  },
  async getBooking(id) {
    const segmentState = store.state.user.segment;
    const params = {
      tz_offset: segmentState.tz_offset,
      segment: segmentState.id,
    };
    const response = await HTTP.get(`/bookings/${id}`, { params });
    return response.data;
  },
  async getMimkBookings(start, end, mimkId, future, getMcAfterCahngeMimk) {
    const tz_offset = store.state.user.segment.tz_offset;
    let segment = store.state.user.segment.id;
    if (getMcAfterCahngeMimk) {
      let mimkList = await apiMimk.getMimkList();
      const foundMimk = mimkList.find((element) => element.id === mimkId);
      segment = foundMimk.segments.toString();
    } else {
      if (store.state.user.segmentsList.length > 1) {
        let segmentArr = [];
        store.state.user.segmentsList.forEach((el) => {
          segmentArr.push(el.id);
        });
        segment = segmentArr.toString();
      }
    }
    const params = {
      mimk: mimkId,
      date_start: start,
      date_end: end,
      future,
      tz_offset,
      segment,
    };
    const response = await HTTP.get("/bookings/", { params });
    console.log(response.data);
    return response.data;
  },
  async getBookingsAll(date, dateTo) {
    const segmentState = store.state.user.segment;
    const params = {
      date_start: date,
      tz_offset: segmentState.tz_offset,
      segment: segmentState.id,
    };
    if (dateTo) {
      params.date_end = dateTo;
    }
    const response = await HTTP.get("/bookings/get_all/", { params });
    return response.data;
  },
  async getMkByLink(link, id) {
    try {
      const segmentState = store.state.user.segment;

      const params = {
        mimk: id,
        amo_link: link,
        tz_offset: segmentState.tz_offset,
        segment: segmentState.id,
      };
      const response = await HTTP.get("/bookings/get_by_amo_link/", { params });
      return response.data;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async newBooking(data) {
    try {
      const segmentState = store.state.user.segment;
      const params = {
        m1: store.state.user.user.id,
        m1_name: store.state.user.user.full_name,
        amocrm_id: data.amocrm_id,
        department: data.department,
        mk_starts_at: data.mk_starts_at,
        mk_ends_at: data.mk_ends_at,
        additional_info: data.additional_info,
        tz_offset: data.tz_offset,
        segment: segmentState.id,
        client_time: data.client_time,
        client_timezone_text: data.client_timezone_text,
        client_tz_offset: data.client_tz_offset,
      };
      const response = await HTTP.post("/bookings/", params);

      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
  async newBookingFreeCourse(data) {
    try {
      const segmentState = store.state.user.segment;
      const params = {
        m1: store.state.user.user.id,
        m1_name: store.state.user.user.full_name,
        amocrm_id: data.amocrm_id,
        department: data.department,
        mk_starts_at: data.mk_starts_at,
        mk_ends_at: data.mk_ends_at,
        additional_info: data.additional_info,
        tz_offset: data.tz_offset,
        segment: segmentState.id,
        client_time: data.client_time,
        client_timezone_text: data.client_timezone_text,
        client_tz_offset: data.client_tz_offset,
      };
      const response = await HTTP.post('/bookings/free_course/', params)
      return response.data
    } catch (err) {
      console.log(err.response);
    }
  },
  async removeBooking(id, query) {
    const response = await HTTP.delete(`/bookings/${id}?${query}`);
    console.log(response);
  },

  async updateFirstConfirmation(booking_id, firstConfirmationData) {
    try {
      await HTTP.put(`/bookings/${booking_id}/first_confirmation`, firstConfirmationData);
    } catch (err) {
      console.error(err);
    }
  },

  async updateBooking(id, data, isAppoint) {
    try {
      console.log(isAppoint);
      if (data.hour_before_confirmed) {
        data.m1_confirmation_name = store.state.user.user.full_name;
        data.m1_confirmation = store.state.user.user.id;
      }
      const segmentState = store.state.user.segment;
      data.tz_offset = segmentState.tz_offset;
      await HTTP.put(`/bookings/${id}`, data);
      return "ok";
    } catch (err) {
      console.log(err.response);
    }
  },
  async reschedulingBooking(id, data) {
    try {
      const params = {
        m1: store.state.user.user.id,
        m1_name: store.state.user.user.full_name,
        ...data,
      };
      const response = await HTTP.post(`/rescheduling_booking/${id}`, params);

      return response.data._id;
    } catch (err) {
      console.log(err.response);
    }
  },
  async getRejectionReasons() {
    const response = await HTTP.get("/bookings/rejection_reasons/");
    return response.data;
  },

  async addSuccessMkinfo(id, status, modalInfo, is_deleted) {
    let fetchObject = {
      status,
      tz_offset: store.state.user.segment.tz_offset,
    };
    if (modalInfo?.comment) fetchObject.comment = modalInfo.comment;
    if (modalInfo?.reason) fetchObject.rejection_reason = modalInfo.reason;
    if (is_deleted !== undefined) fetchObject.is_deleted = is_deleted;
    await HTTP.put(`/bookings/${id}`, fetchObject)
      .then(() => {
        Vue.toasted.global.all_ok(i18n.t("ok.statusSaved"));
      })
      .catch(() => {
        return false;
      });
  },
  async manualDistribute() {
    try {
      const segmentState = store.state.user.segment;
      await HTTP.post(
        `/manual_distribute_mk/?tz_offset=${segmentState.tz_offset}&segment=${segmentState.id}`
      );
      Vue.toasted.global.all_ok(i18n.t("ok.mkAssigned"));
    } catch (e) {
      console.log(e);
    }
  },

  async getSegmentInfo(segment) {
    try {
      const response = await HTTP.get(`segments/?title=${segment}`);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  },
  async getOverbooking() {
    try {
      const response = await HTTP.get(
        `matrix_by_segment/${store.state.user.segment.id}`
      );
      return response.data;
    } catch (e) {
      console.log(e);
    }
  },
  async changeMatrixData(matrixData, matrixId) {
    try {
      await HTTP.put(`/matrix/?matrix_id=${matrixId}`, matrixData);

      Vue.toasted.global.all_ok(i18n.t("overbooking.toast"));
      return "ok";
    } catch (err) {
      console.log(err.response);
    }
  },
  async getCkientOrders(studentId) {
    try {
      const response = await BACKOFFICE.get(
        `/client_orders/?student_id=${studentId}`
      );
      return response.data.items;
    } catch (err) {
      console.log(err.response);
    }
  },
  async checkLocalTime(tz_offset, time) {
    try {
      const response = await HTTP.get(
        `/check_local_time/?tz_offset=${tz_offset}&client_time=${time}`
      );
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
  async getClosest() {
    const segment = store.state.user.segment;
    try {
      const response = await HTTP.get(
        `/bookings/get_with_second_confirmation/?segment=${segment.id}&tz_offset=${segment.tz_offset}`
      );
      console.log(response.data);
      return response.data;
    } catch (err) {
      console.log(err.response);
      return [];
    }
  },
  async m1DistribRules() {
    const segment = store.state.user.segment;
    try {
      const response = await HTTP.get(
        `/m1_booking_distribution_rules/?segment=${segment.id}`
      );
      return response.data.num_of_bookings_per_m1;
    } catch (err) {
      console.log(err.response);
      return [];
    }
  },
  async migrateSummerTime(payload) {
    try {
      await HTTP.post("/migrate_summer_time/", payload);
      Vue.toasted.global.all_ok(i18n.t("ok.saved"));
    } catch (err) {
      console.log(err.response);
    }
  },
  async getInfoLead(amocrm_id) {
    try {
      const response = await HTTP.get(
        `/clients/data_from_amocrm/?amocrm_id=${amocrm_id}`
      );
      console.log(response.data);
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
};
